/**
 * Prefer API ErrorDetails.message (or string body) over hard-coded contact text.
 */
export const getApiErrorMessage = (error: unknown, fallback: string): string => {
    const err = error as {
        response?: { data?: { message?: string } | string };
        message?: string;
    };
    const data = err?.response?.data;
    if (typeof data === "string" && data.trim()) {
        return data;
    }
    if (
        data &&
        typeof data === "object" &&
        typeof data.message === "string" &&
        data.message.trim()
    ) {
        return data.message;
    }
    if (
        typeof err?.message === "string" &&
        err.message.trim() &&
        !err.message.startsWith("Request failed")
    ) {
        return err.message;
    }
    return fallback;
};
